import React, {useState} from 'react';
import BurgerMenu from '../../navigation/burgerMenu';
import {BackButton} from '../../BackButton';
import {NavLink, useNavigate} from 'react-router-dom';

interface OrganizerHeaderProps {
  name: string;
  companyName: string;
  onClear: () => void;
  showBack?: boolean;
  onBackButtonClick?: (() => void) | null;
  viewMode: 'events' | 'places';
  onChangeViewMode: (mode: 'events' | 'places') => void;
}

export const OrganizerHeader: React.FC<OrganizerHeaderProps> = ({
  name,
  companyName,
  onClear,
  showBack = false,
  onBackButtonClick,
  viewMode,
  onChangeViewMode,
}) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isToggleHovered, setIsToggleHovered] = useState(false);
  const isEvent = viewMode === 'events';
  const navigate = useNavigate();

  return (
    <header
      className="organizer-header"
      style={{
        position: 'fixed',
        top: 0,
        // Starts where the sidebar ends (see burgerMenuStyle.css).
        left: 'var(--nav-width, 0px)',
        right: 0,
        height: '100px',
        backgroundColor: '#1a1a1a',
        borderBottom: '1px solid #333',
        display: 'flex',
        alignItems: 'center', // Vertical centering for the whole bar
        padding: '0 25px',
        zIndex: 1000,
        boxShadow: '0 4px 15px rgba(0,0,0,0.5)',
      }}>
      {/* 1. Left Container: Centered vertically */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          alignItems: 'center', // Ensures Burger or Back is centered
          gap: '12px',
          height: '100%',
        }}>
        <BurgerMenu />
        {showBack && <BackButton onClick={onBackButtonClick} />}
      </div>

      {/* 2. Center Info */}
      <div
        className="organizer-header-info"
        style={{
          flex: 2,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center',
        }}>
        <h1
          style={{
            color: '#fff',
            margin: 0,
            fontSize: '1.5rem',
            fontWeight: 700,
            letterSpacing: '-0.5px',
          }}>
          Welcome, <span style={{color: '#daff00'}}>{name}</span>
        </h1>
        <p style={{color: '#aaa', margin: '4px 0 0 0', fontSize: '1.0rem'}}>
          {companyName} — {isEvent ? 'Events' : 'Places'}
        </p>
      </div>

      {/* 3. Right Action */}
      <div
        className="organizer-header-actions"
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'flex-end',
          gap: '12px',
        }}>
        <button
          onClick={() => {
            const targetMode = isEvent ? 'places' : 'events';
            const targetPath = isEvent ? '/places/all' : '/events/all';
            onChangeViewMode(targetMode);
            navigate(targetPath);
          }}
          onMouseEnter={() => setIsToggleHovered(true)}
          onMouseLeave={() => setIsToggleHovered(false)}
          style={{
            backgroundColor: isToggleHovered ? '#adff2f' : 'transparent',
            color: isToggleHovered ? '#1a1a1a' : '#adff2f',
            border: '2px solid #adff2f',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '0.8rem',
            transition: 'all 0.3s ease',
            outline: 'none',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {viewMode === 'events' ? 'Change to Places' : 'Change to Events'}
        </button>

        <button
          onClick={onClear}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{
            backgroundColor: isHovered ? '#ff4d4d' : 'transparent',
            color: isHovered ? '#fff' : '#ff4d4d',
            border: '2px solid #ff4d4d',
            padding: '10px 20px',
            borderRadius: '8px',
            cursor: 'pointer',
            fontWeight: 'bold',
            fontSize: '0.8rem',
            transition: 'all 0.3s ease',
          }}>
          Clear Organizer
        </button>
      </div>
    </header>
  );
};
